﻿$(function () {
    $('[name$="CountryIso"]').on('change', function () {
        var form = $(this).parents('form');
        if (form.length) {
            if (form.find('.form-group--region[data-country="' + $(this).val() + '"], .form-group--postcode[data-country="' + $(this).val() + '"]').length > 0) {
                form.find('.form-group--region, .form-group--postcode').addClass('d-none').find('input,select').prop('disabled', true);
                form.find('.form-group--region[data-country="' + $(this).val() + '"], .form-group--postcode[data-country="' + $(this).val() + '"]').removeClass('d-none').find('input,select').prop('disabled', false);
            } else {
                form.find('.form-group--region, .form-group--postcode').removeClass('d-none').find('input,select').prop('disabled', false);
                form.find('.form-group--region[data-country], .form-group--postcode[data-country]').addClass('d-none').find('input,select').prop('disabled', true);
            }
            if (form.find('[name$="Postcode"]').length) {
                form.find('[name$="Postcode"]').valid();
            }
        }
    }).trigger('change');
});
